import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterWrapper = styled(Box)`
  background-color: ${props => props.theme.colors.primary.main};
  color: white;
  padding: ${props => props.theme.spacing(6)} 0;
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              About Bizscape
            </Typography>
            <Typography variant="body2" paragraph>
              Empowering businesses with innovative solutions through our flagship product BizXHub.
              We're committed to helping businesses thrive in the digital age.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0 }}>
              <Box component="li" sx={{ mb: 1 }}>
                <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
                  Home
                </Link>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <Link to="/services" style={{ color: 'inherit', textDecoration: 'none' }}>
                  Services
                </Link>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" paragraph>
              Belle Mead, NJ 08502
            </Typography>
            <Typography variant="body2" paragraph>
              Email: info@bizscape.us
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
          <Typography variant="body2" textAlign="center">
            © {new Date().getFullYear()} Bizscape. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </FooterWrapper>
  );
};

export default Footer; 
